import axiosClient from "utils";

const fetchStat = async (params) => {
  const url = `/v1/statistic`;
  return axiosClient.get(url, { params });
};

export { fetchStat };
